import {
  getChannelUrl,
  isTeamMessengerChannel,
} from "Messenger/hooks/channelData.helpers";
import constants from "constants";
import { showDesktopNotification } from "utils/firebaseMessaging";

let lastNotifyKey = "";
let lastNotifyAt = 0;

/**
 * Shows a desktop notification for an incoming Sendbird message.
 * Dedupes when both the global SDK handler and the conversation handler fire.
 *
 * @param {object} channel
 * @param {object} message
 * @param {string|number|null|undefined} currentUserId
 */
export function notifyIncomingSendbirdMessage(channel, message, currentUserId) {
  if (!channel || !message) return;

  const senderId =
    message.sender?.userId != null ? String(message.sender.userId) : "";
  const myId = currentUserId != null && currentUserId !== "" ? String(currentUserId) : "";
  if (senderId && myId && senderId === myId) return;

  const customType = channel?.customType || channel?.custom_type || "";
  const isPatientChannel =
    customType === constants.chat.patient.open ||
    customType === constants.chat.patient.close;
  if (!isTeamMessengerChannel(channel) && !isPatientChannel) return;

  const messageId = message.messageId || message.reqId || message.createdAt || "";
  const key = `${getChannelUrl(channel)}:${messageId}`;
  const now = Date.now();
  if (key === lastNotifyKey && now - lastNotifyAt < 2500) return;
  lastNotifyKey = key;
  lastNotifyAt = now;

  const sendbird = {
    channel: {
      channel_url: getChannelUrl(channel),
      name: channel.name,
      custom_type: customType,
    },
    sender: {
      id: message.sender?.userId,
      name: message.sender?.nickname,
    },
    message: message.message || message.name || "",
  };

  void showDesktopNotification({
    data: {
      sendbird: JSON.stringify(sendbird),
      message: sendbird.message,
    },
  });
}
